import React, { useEffect, useState } from 'react';

const Toast = ({ successfully, errorMessage }) => {
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success'); // 'success' or 'error'

  useEffect(() => {
    if (successfully) {
      setMessage(successfully);
      setType('success');
      setShowToast(true);
    } else if (errorMessage) {
      setMessage(errorMessage);
      setType('error');
      setShowToast(true);
    }

    const timer = setTimeout(() => {
      setShowToast(false);
    }, 3000); // Hide after 3 seconds

    return () => clearTimeout(timer);
  }, [successfully, errorMessage]);

  const toastStyle = {
    ...styles.toast,
    backgroundColor: type === 'success' ? '#51bc6aff' : '#e74c3c', // green or red
  };

  return (
    <>
      {showToast && (
        <div style={toastStyle}>
          {message}
        </div>
      )}
    </>
  );
};

const styles = {
  toast: {
    position: 'fixed',
    top: '20px',
    right: '20px',
    color: '#fff',
    padding: '12px 20px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    zIndex: 9999,
    fontSize: '14px',
    animation: 'fadein 0.3s, fadeout 0.5s 2.5s',
    transition: 'all 0.3s ease',
  }
};

export default Toast;
